// Redirect to original page
(() => {
	let redirect = null;

	const params = new URLSearchParams(window.location.search);
	redirect = params.get('redirect');

	if (!redirect && sessionStorage.getItem('btLoginRedirect')) {
		redirect = sessionStorage.getItem('btLoginRedirect');
	}

	if (redirect) {
		console.log('Set redirect to', redirect);
		let input = document.createElement('input');
		input.type = 'hidden';
		input.name = 'return_to';
		input.value = redirect;
		document.querySelectorAll('#CustomerLoginForm form, #RegisterForm').forEach(form => form.appendChild(input));
		sessionStorage.setItem('btLoginRedirect', redirect);
	}
})();

// Inject marketing checkbox into social log-in form
(() => {
	const forms = document.querySelectorAll('#CustomerLoginForm, #RegisterForm');

	for (const form of forms) {
		const observer = new MutationObserver(_ => {
			const buttons = form.querySelector('.h_buttons');
			
			if (buttons) {
				observer.disconnect();
				buttons.insertAdjacentHTML('afterend', /* html */`
					<style>
						.social-marketing-checkbox {
							display: flex;
							gap: 4px;
							align-items: center;
							margin-top: 8px;
						}

						.social-marketing-checkbox label {
							font-size: 14px;
						}

						.social-marketing-checkbox input {
							-webkit-appearance: none;
							appearance: none;
							padding: 0;
							width: 15px !important;
							height: 15px;
							position: relative;
							box-shadow: 0px 0px 0px 0px transparent inset;
							transition: box-shadow 0.3s ease-in-out;
							margin: 0;
							border-radius: 2px;
						}

						.social-marketing-checkbox  input:checked {
							box-shadow: 0px 0px 10px 5px rgb(0,0,0) inset;
							transition: box-shadow 0.3s ease-in-out;
						}

						.social-marketing-checkbox input::before {
							content: '';
							display: block;
							position: absolute;
							width: 8px;
							height: 5px;
							border-bottom: 2px solid #FFFFFF;
							border-left: 2px solid #FFFFFF;
							transform: rotateZ(-45deg) scale(0.6);
							top: 0;
							bottom: 2px;
							right: 0;
							left: 1px;
							margin: auto;
							z-index: 2;
							opacity: 0;
							transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
						}

						.social-marketing-checkbox input:checked::before {
							opacity: 1;
							transform: rotateZ(-45deg) scale(1);
							transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
						}

						@media screen and (min-width: 992px) {
							.social-marketing-checkbox label {
								font-size: 16px;
							}
						}
					</style>
					<div class="social-marketing-checkbox">
						<input type="checkbox" name="accepts_marketing" value="true" id="social-marketing">
						<label for="social-marketing">Yes, I want exclusive offers, linen advice, and inspiration in my inbox.</label>
					</div>
				`);
			}
		});

		observer.observe(form, { childList: true, subtree: true });
	}
})()


// Forgot password handler
document.getElementById('RecoverPassword').addEventListener('click', () => {
	document.getElementById('RecoverPasswordForm').classList.remove('hide');
	document.getElementById('CustomerLoginForm').classList.add('hide');
});

document.getElementById('HideRecoverPasswordLink').addEventListener('click', () => {
	document.getElementById('RecoverPasswordForm').classList.add('hide');
	document.getElementById('CustomerLoginForm').classList.remove('hide');
});